* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  --dashboard-toolbar: calc(var(--spacer) * 5);
  --gz-header: 56px;
  --gz-reporting-period: 31px;
  --gz-dashboard-filters-bar: calc(var(--spacer) * 8);
}

.wrapper {
  padding: 2px;
}

.border {
  border: none;
}

#fullscreen-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

gz-dashboard-filters-bar {
  display: flex;
  flex-direction: column;
}

#dashboard-grid-stack {
  overflow: auto;

  &.pdf-mode {
    overflow: visible;

    gz-dashboard-grid-stack-manager {
      overflow: visible;
    }
  }
}

#dashboard-toolbar {
  height: var(--dashboard-toolbar);
  padding: 0 calc(var(--spacer) * 2.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

#fullscreen-content::backdrop {
  // set background on fullscreen mode
  background-color: var(--white-layout-301-level-0-elevation);
}

gz-dashboard-grid-stack-manager {
  overflow: auto;
}

gz-push-body-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  &::part(header) {
    padding-left: calc(var(--spacer) * 2);
  }
  &::part(content) {
    height: 100%;
  }
}

.feedback-toolbar {
  padding: 0 calc(var(--spacer) * 18) 0 calc(var(--spacer) * 3 - 4px);

  &.pdf-mode {
    padding: 0 calc(var(--spacer) * 2 - 4px) 0 calc(var(--spacer) * 4 - 8px);
  }
}
